export default "__VITE_ASSET__BPaTaLCR__"